import { render, staticRenderFns } from "./type-textarea.vue?vue&type=template&id=3389f648&scoped=true&"
import script from "./type-textarea.vue?vue&type=script&lang=js&"
export * from "./type-textarea.vue?vue&type=script&lang=js&"
import style0 from "./type-textarea.vue?vue&type=style&index=0&id=3389f648&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3389f648",
  null
  
)

export default component.exports